import { render, staticRenderFns } from "./DocumentQA.vue?vue&type=template&id=1de2efef&"
import script from "./DocumentQA.vue?vue&type=script&lang=js&"
export * from "./DocumentQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports